import { AUTH, LOGOUT } from '../constants/actionTypes'
const auth = (state = {tokenData: null}, action) => {
    switch (action.type) {
        case AUTH:
            localStorage.setItem('retailer', JSON.stringify({...action?.payload}))
            return {...state, tokenData: action?.payload}
        case LOGOUT:
            localStorage.clear()
            return {...state, tokenData: null}
    
        default:
            return state
    }
}

export default auth